export default __webpack_public_path__ + "static/media/es-buurebueebli.9f79f8b9.pdf";